import { Fragment } from 'react';
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';

import { FHCopyToClipboard } from '../../../base';

import type { IClaimServiceLine } from '../../../../utils/types';

interface Claim1500FormServiceLinesProps {
  serviceLines: IClaimServiceLine[];
}

const tableStyle = {
  '& .MuiTableCell-root': {
    padding: '4px 8px',
    border: 'none',
  },
};

function Claim1500FormServiceLines(props: Claim1500FormServiceLinesProps) {
  const { serviceLines } = props;

  return (
    <Box sx={{ mb: 3 }}>
      <TableContainer sx={tableStyle}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell></TableCell>
              <TableCell>
                <Typography fontWeight={700}>24a. Date(s) of service</Typography>
              </TableCell>
              <TableCell>
                <Typography fontWeight={700}>24b. Place. of serv.</Typography>
              </TableCell>
              <TableCell>
                <Typography fontWeight={700}>24d. Prodc. Serv. Supp.</Typography>
              </TableCell>
              <TableCell>
                <Typography fontWeight={700}>24e. Diagnosis P.</Typography>
              </TableCell>
              <TableCell>
                <Typography fontWeight={700}>24f. $ charges</Typography>
              </TableCell>
              <TableCell>
                <Typography fontWeight={700}>24g. Days or Units</Typography>
              </TableCell>
              <TableCell>
                <Typography fontWeight={700}>24i. NPI</Typography>
              </TableCell>
              <TableCell>
                <Typography fontWeight={700}>24j. BCBA NPI</Typography>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {serviceLines.map((serviceLine: IClaimServiceLine, index: number) => (
              <TableRow key={index}>
                <TableCell>
                  <Typography fontWeight={700}>{index + 1}.</Typography>
                </TableCell>
                <TableCell sx={{ display: 'flex', alignItems: 'center' }}>
                  <FHCopyToClipboard
                    text={
                      (serviceLine?.date_of_service?.split('-')[1] || '') +
                      ' / ' +
                      (serviceLine?.date_of_service?.split('-')[2] || '') +
                      ' / ' +
                      (serviceLine?.date_of_service?.split('-')[0] || '')
                    }
                  />
                </TableCell>
                <TableCell>
                  <FHCopyToClipboard text={String(serviceLine?.location) || ''} />
                </TableCell>
                <TableCell sx={{ display: 'flex' }}>
                  <FHCopyToClipboard text={serviceLine?.cpt_or_hcpcs_code || ''} />
                  {serviceLine?.modifier && <Typography> - </Typography>}
                  {serviceLine?.modifier &&
                    serviceLine?.modifier.length > 0 &&
                    serviceLine?.modifier.map((mod, i) => (
                      <Fragment key={mod}>
                        <FHCopyToClipboard text={mod} />
                        {i !== (serviceLine.modifier?.length ?? 0) - 1 && (
                          <Typography ml={-0.5} mr={0.5}>
                            ,
                          </Typography>
                        )}
                      </Fragment>
                    ))}
                </TableCell>
                <TableCell>
                  <FHCopyToClipboard text={serviceLine?.diagnosis_pointer || ''} />
                </TableCell>
                <TableCell>
                  <FHCopyToClipboard text={String(serviceLine?.charges) || ''} />
                </TableCell>
                <TableCell>
                  <FHCopyToClipboard text={String(serviceLine?.units) || ''} />
                </TableCell>
                <TableCell>
                  <FHCopyToClipboard text={serviceLine?.id_qual || ''} />
                </TableCell>
                <TableCell>
                  <FHCopyToClipboard text={serviceLine?.bcba_npi || ''} />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}

export default Claim1500FormServiceLines;
